import React from 'react';
import '../../styles/mainContents.css'
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

function MainHeader(props) {

  const history = useHistory();

  const { authreducer, pageTitle } = props;

  const routeChange_batteryCorporate = () =>{ 
    let path = `/battery/corporate`; 
    history.push(path);
  }

  
  return (

    <header className="mainCN----">

      <div className='MainPageCN'>      
        <div className="MainPageHeading">                  
          <h1 className="MainPageTitle">
            <div>3rd Party Consignments {pageTitle}</div>
            <div className='svrtms' style={ {float:'left'} }>{ moment().format("llll") } </div>
          </h1>
          {/* <div style={ {clear: 'both'}}></div> */}
          <p style={{ textAlign: 'end', paddingRight: '30px', color: 'white', fontWeight: 'bold', verticalAlign: 'bottom' }}>FMP Contact: Tim Denardo - Phone: 920-224-2445 - email: directshippartner@fmpco.com</p>
          {/* <ul id='nav'>
            <li>
              <button
                onClick={ () => {
                  //routeChange_batteryCorporate()
                }}
                > Corporate Placeholder
              </button> 
            </li>
            <li>
              <button
                onClick={ () => {
                  routeChange_batteryCorporate()
                }}
                > Warehouse Placeholder
              </button> 
            </li>            
          </ul> */}
        </div>        
      </div>
    </header>

  );
}


const mapStateToProps = (state) => {
  //console.log("MainHeader mapStateToProps state: " + JSON.stringify(state));
 return {
   authreducer: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  //console.log("MainHeader mapDispatchToProps called ");
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainHeader);